namespace My {
    export class FastLinkVerificationResetPassword extends BaseForm<FastLinkVerificationModel, any> {
        protected formRestPassword = $('.form-rest-password');
        protected $btnSubmitForm = $("#btn-submit-reset-password")
        private _passwordRecoveryService: PasswordRecoveryService
        constructor(container: JQuery, opt?: any) {
            super(container, opt);
        }

        protected onInit(): void {
            this._passwordRecoveryService = new PasswordRecoveryService()
        }

        protected bindingEvents(): void {
            this.$btnSubmitForm.on("click", () => {
                var type = this.$btnSubmitForm.data("reset-type")
                this.submitFormResetPassword(type.toString());
            })
        }

        public validatePasswood(passwood) {
            var re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-=_+{};':"\\|,.<>\/?]).{8,32}$/;
            return re.test(passwood);
        }

        public validateFormResetPassword() {
            var $password = $("#Password").val();
            var $confirmPassword = $("#ConfirmPassword").val();
            var isValidate = true;
            this.resetErrMsg();
            if (!this.validatePasswood($password) && $password != "") {
                // Hiện lỗi regex
                $("#Password").data("err-msg", Utils.l("ResetPassword.Validate.Regex"))
                isValidate = false;
            }
            if ($confirmPassword != $password && $confirmPassword != "") {
                // hiện lỗi trùng
                $("#ConfirmPassword").data("err-msg", Utils.l("ResetPassword.Validate.Unduplicated"))
                isValidate = false;
            }
            if ($password == "") {
                $("#Password").data("err-msg", Utils.l("ResetPassword.Validate.InputEmpty"))
                isValidate = false;
            }
            if ($confirmPassword == "") {
                $("#ConfirmPassword").data("err-msg", Utils.l("ResetPassword.Validate.InputEmpty"))
                isValidate = false;
            }
            this.showError();

            return isValidate;
        }

        public showError() {
            this.formRestPassword.find('input[required]').each(function () {
                var input = $(this)
                var formGroup = $(this).closest('.form-group')[0]
                var errSpan = $(formGroup).siblings(".error-massage")[0]
                $('.message-note-invalid').addClass('d-none');
                $(formGroup).closest('.form-group-invalid').addClass('mb-3').removeClass('mb-5');
                $(errSpan).html("");
                var msg = input.data("err-msg")
                if (msg != "") {
                    $(errSpan).html(msg)
                }
            })
        }

        public resetErrMsg() {
            this.formRestPassword.find('input').each(function () {
                $(this).data("err-msg", "")
            })
        }

        public async submitFormResetPassword(type) {
            if (this.validateFormResetPassword()) {
                var model = {
                    Token: $("#token-box").text(),
                    NewPassword: $('#ConfirmPassword').val(),
                    PhoneNumber: $('#PhoneNumber').val(),
                    DomainName: "fastlink"
                }
                var response = null;
                if (type == "PhoneNumber") {
                    response = await this._passwordRecoveryService.resetPassswordByPhoneNumber(model);
                } else {
                    response = await this._passwordRecoveryService.resetPassswordByEmail(model);
                }
                console.log(response)
                if (response.Code == '0') {
                    UIUtils.showSuccess(Utils.l("ResetPassword.ToastSuccess"), () => {
                        window.location.href = "/";
                    });
                } else {
                    UIUtils.showWarning(Utils.l("ResetPassword.ToastError"));
                }
            }     
        }
    }
}